import { render } from "./yapilacakCard.vue?vue&type=template&id=457f534e"
import script from "./yapilacakCard.vue?vue&type=script&lang=js"
export * from "./yapilacakCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__